import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ContentProvider } from './contexts/ContentContext';
import LandingPage from './pages/LandingPage';
import ContactPage from './pages/ContactPage';
import SectorDetailPage from './pages/SectorDetailPage';
import AllOpportunitiesPage from './pages/AllOpportunitiesPage';
import { MapPage } from './pages/MapPage';
import { LoginPage } from './pages/LoginPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import SimpleUnifiedDashboard from './pages/admin/SimpleUnifiedDashboard';
import { ManagePOIs } from './pages/admin/ManagePOIs';
import { ManageCategories } from './pages/admin/ManageCategories';
import { ManageLayers } from './pages/admin/ManageLayers';
import { ManageTranslations } from './pages/admin/ManageTranslations';
import InvestmentOpportunityManagement from './components/InvestmentOpportunityManagement';
import ProfileAdvantageEditor from './pages/admin/ProfileAdvantageEditor';
import FacilityEditor from './pages/admin/FacilityEditor';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Toaster } from './components/Toaster';
import './App.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <ContentProvider>
          <AuthProvider>
            <Router>
            <div className="App">
              <Routes>
                {/* Public routes */}
                <Route path="/" element={<LandingPage />} />
                <Route path="/peta-potensi" element={<MapPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/semua-peluang-investasi" element={<AllOpportunitiesPage />} />
                <Route path="/sectors/:sectorId" element={<SectorDetailPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
                
                {/* Protected admin routes */}
                <Route path="/admin" element={
                  <ProtectedRoute>
                    <SimpleUnifiedDashboard />
                  </ProtectedRoute>
                } />
                <Route path="/admin/pois" element={
                  <ProtectedRoute>
                    <ManagePOIs />
                  </ProtectedRoute>
                } />
                <Route path="/admin/categories" element={
                  <ProtectedRoute>
                    <ManageCategories />
                  </ProtectedRoute>
                } />
                <Route path="/admin/layers" element={
                  <ProtectedRoute>
                    <ManageLayers />
                  </ProtectedRoute>
                } />
                <Route path="/admin/translations" element={
                  <ProtectedRoute>
                    <ManageTranslations />
                  </ProtectedRoute>
                } />
                <Route path="/admin/investment-opportunities" element={
                  <ProtectedRoute>
                    <InvestmentOpportunityManagement />
                  </ProtectedRoute>
                } />
                <Route path="/admin/advantages/new" element={
                  <ProtectedRoute>
                    <ProfileAdvantageEditor />
                  </ProtectedRoute>
                } />
                <Route path="/admin/advantages/:advantageId" element={
                  <ProtectedRoute>
                    <ProfileAdvantageEditor />
                  </ProtectedRoute>
                } />
                <Route path="/admin/facilities/new" element={
                  <ProtectedRoute>
                    <FacilityEditor />
                  </ProtectedRoute>
                } />
                <Route path="/admin/facilities/:facilityId" element={
                  <ProtectedRoute>
                    <FacilityEditor />
                  </ProtectedRoute>
                } />
              </Routes>
              
              <Toaster />
            </div>
          </Router>
        </AuthProvider>
      </ContentProvider>
    </LanguageProvider>
  </QueryClientProvider>
  );
}

export default App;
